import { ChevronDown, Globe, Menu } from "lucide-react";
import { useCallback, useState } from "react";

import MenuOverlay from "../menu/MenuOverlay";
import { useTranslation } from "react-i18next";

const Header = () => {

    const { i18n } = useTranslation();
    const [menuOpen, setMenuOpen] = useState(false);
    const [languageDropdownOpen, setLanguageDropdownOpen] = useState(false);

        const handleCloseMenu = useCallback(() => setMenuOpen(false), [setMenuOpen]);

        const handleOpenMenu = useCallback(() => setMenuOpen(true), [setMenuOpen]);

        const toggleLanguageDropdown = useCallback(() => setLanguageDropdownOpen(prev => !prev), []);

        const changeLanguage = useCallback((lng) => {
            i18n.changeLanguage(lng);
            setLanguageDropdownOpen(false);
        }, [i18n]);

    return (
        <header className="px-6 lg:px-12 py-6 lg:py-8">
            <div className="flex items-center justify-between">
                <div className="flex items-center space-x-3">
                    <h1 className="text-2xl lg:text-4xl font-semibold text-white lg:block">Meets<span className="text-lime-700 font-bold">&</span>Works</h1>
                </div>

                {/* Language Dropdown and Menu Icon */}
                <div className="flex items-center space-x-4">
                    {/* Language Dropdown */}
                    <div className="relative">
                        <button
                            onClick={toggleLanguageDropdown}
                            className="flex items-center space-x-2 text-white hover:text-lime-300 transition-colors"
                        >
                            <Globe className="w-5 h-5" />
                            <span className="text-sm font-medium">
                                {i18n.language === 'sw' ? 'SW' : 'EN'}
                            </span>
                            <ChevronDown className="w-4 h-4" />
                        </button>

                        {languageDropdownOpen && (
                            <div className="absolute right-0 mt-2 w-32 bg-white rounded-md shadow-lg z-50">
                                <div className="py-1">
                                    <button
                                        onClick={() => changeLanguage('en')}
                                        className={`block w-full px-4 py-2 text-sm hover:bg-gray-100 text-left ${
                                            i18n.language === 'en' ? 'bg-lime-50 text-lime-700' : 'text-gray-700'
                                        }`}
                                    >
                                        English
                                    </button>
                                    <button
                                        onClick={() => changeLanguage('sw')}
                                        className={`block w-full px-4 py-2 text-sm hover:bg-gray-100 text-left ${
                                            i18n.language === 'sw' ? 'bg-lime-50 text-lime-700' : 'text-gray-700'
                                        }`}
                                    >
                                        Kiswahili
                                    </button>
                                </div>
                            </div>
                        )}
                    </div>

                    {/* Menu Icon */}
                    <Menu
                        onClick={handleOpenMenu}
                        className="w-8 h-8 text-white cursor-pointer"
                    />
                </div>

                <MenuOverlay
                    isOpen={menuOpen}
                    onClose={handleCloseMenu}
                />
            </div>
        </header>
    );
};

export default Header;
